import { Globe, Check } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { LANGS, useI18n } from "@/lib/i18n";

export const LangSwitch = ({ light = false }) => {
  const { lang, setLang } = useI18n();
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        data-testid="language-selector-dropdown"
        className={`flex items-center gap-2 rounded-full border px-3 py-2 font-mono text-xs tracking-widest transition-colors duration-300 ${light ? "border-white/30 text-paper hover:bg-white/10" : "border-ink/15 text-ink hover:bg-ink/5"}`}
      >
        <Globe className="h-4 w-4" /> {lang.toUpperCase()}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px] bg-paper">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} data-testid={`lang-option-${l.code}`} onClick={() => setLang(l.code)} className="flex justify-between">
            {l.label} {lang === l.code && <Check className="h-4 w-4 text-accent2" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
